/* DON'T EDIT THIS FILE: edit original and run build again */ export const verifyConformanceToCurrentPolicyRequiredActionId =
  "doesNotConformToCurrentPolicy";

export const enforceVerifyConformanceToCurrentPolicyId =
  "enforceCurrentPolicyVerify";
